import { distinctGuids } from "@/app/apiutils";
import Guid from "@/app/types/common/guid";
import { GuidSet } from "@/app/types/common/guidcollections";

export class Guids {
  public static fromStrings(strings: readonly string[]) {
    return strings.map((x) => Guid.tryParse(x)).filter((x): x is Guid => !!x);
  }

  public static intersect(a: readonly Guid[], b: readonly Guid[]) {
    const setB = new GuidSet(b);
    return distinctGuids(a).filter((x) => setB.has(x));
  }

  public static allAreGuids(items: any): items is Guid[] {
    return Array.isArray(items) && items.every((item) => Guid.isGuid(item));
  }

  public static justGuids(items: any) {
    const itemArray = Array.isArray(items) ? items : [items];
    return itemArray.filter((x) => x instanceof Guid);
  }
}
